/* SOAR Hoop Product buy box.
   - Gallery thumbnails
   - Add-to-cart: main hoop + (optional) installation add-on in one /cart/add.js call
   - Compare Hoops size-guide modal
   - "Complete Your Court" complementary recommendations (fetch + quick-add)
   - Desktop sticky add-to-cart bar
   Uses the theme cart flow: POST /cart/add.js then dispatch `cart:add`
   (soar-cart-drawer opens + updates the header count). */

const root = document.querySelector('.soar-hoop');

if (root) {
  /* ---------- gallery ---------- */
  const slides = root.querySelectorAll('[data-soar-slide]');
  const thumbs = root.querySelectorAll('[data-soar-thumb]');
  thumbs.forEach((t) => {
    t.addEventListener('click', () => {
      const i = t.dataset.soarThumb;
      slides.forEach((s) => s.classList.toggle('is-active', s.dataset.soarSlide === i));
      thumbs.forEach((x) => x.classList.toggle('is-active', x === t));
    });
  });

  /* ---------- size guide modal ---------- */
  const modal = root.querySelector('[data-soar-sizeguide]');
  if (modal) {
    const open = () => { modal.hidden = false; document.body.classList.add('soar-hoop-lock'); };
    const close = () => { modal.hidden = true; document.body.classList.remove('soar-hoop-lock'); };
    root.querySelectorAll('[data-soar-sizeguide-open]').forEach((b) => b.addEventListener('click', open));
    modal.querySelectorAll('[data-soar-sizeguide-close]').forEach((b) => b.addEventListener('click', close));
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && !modal.hidden) close(); });
  }

  /* ---------- cart helper ---------- */
  async function addItems(items, btn) {
    if (btn) { btn.classList.add('is-loading'); btn.disabled = true; }
    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items }),
      });
      if (!res.ok) {
        const err = await res.json().catch(() => ({}));
        throw new Error(err.description || err.message || 'Could not add to cart');
      }
      document.dispatchEvent(new CustomEvent('cart:add'));
    } catch (e) {
      console.error('[soar-hoop] add to cart failed:', e);
      alert(e.message || 'Could not add to cart.');
    } finally {
      if (btn) { btn.classList.remove('is-loading'); btn.disabled = false; }
    }
  }

  /* ---------- main / sticky add-to-cart (+ installation add-on) ---------- */
  const addonCheck = root.querySelector('[data-default-addon] .default-addon__checkbox');
  root.querySelectorAll('[data-soar-hoop-atc]').forEach((btn) => {
    btn.addEventListener('click', () => {
      const variantId = btn.dataset.variantId;
      if (!variantId || btn.disabled) return;
      const main = { id: variantId, quantity: 1 };
      if (btn.dataset.preorder === 'true' && btn.dataset.preorderEstimate) {
        main.properties = { 'Preorder Estimate': btn.dataset.preorderEstimate };
      }
      const items = [main];
      if (addonCheck && addonCheck.checked) {
        const addonId = addonCheck.dataset.addonVariantId || addonCheck.value;
        if (addonId) items.push({ id: addonId, quantity: 1 });
      }
      addItems(items, btn);
    });
  });

  /* ---------- complete your court (complementary) ---------- */
  const cyc = root.querySelector('[data-soar-complementary]');
  if (cyc && cyc.dataset.url) {
    fetch(cyc.dataset.url)
      .then((r) => (r.ok ? r.text() : ''))
      .then((html) => {
        if (!html) return;
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const wrap = doc.querySelector('.shopify-section') || doc.body;
        if (!wrap || !wrap.querySelector('.soar-hoop__cyc-title')) return;
        cyc.innerHTML = wrap.innerHTML;
        cyc.querySelectorAll('[data-soar-cyc-add]').forEach((b) => {
          b.addEventListener('click', () => {
            const vid = b.dataset.variantId;
            if (vid) addItems([{ id: vid, quantity: 1 }], b);
          });
        });
      })
      .catch(() => {});
  }

  /* ---------- sticky add-to-cart bar (desktop) ---------- */
  const sticky = root.querySelector('[data-soar-sticky]');
  const mainAtc = root.querySelector('.soar-hoop__buybox [data-soar-hoop-atc]');
  if (sticky && mainAtc && 'IntersectionObserver' in window) {
    const io = new IntersectionObserver(
      (entries) => entries.forEach((e) => { sticky.hidden = e.isIntersecting; }),
      { rootMargin: '0px 0px -120px 0px' }
    );
    io.observe(mainAtc);
  }
}
